var map = {
	"./astropay.svg": 541,
	"./bankwire-it.svg": 542,
	"./bankwire.png": 543,
	"./bankwire.svg": 544,
	"./bitcoin.png": 545,
	"./cup.png": 546,
	"./fasapay.png": 547,
	"./ideal.png": 548,
	"./instantbanktransfer.png": 549,
	"./jeton-wallet.png": 550,
	"./jeton.png": 551,
	"./koalapay.png": 552,
	"./lydiax.png": 553,
	"./lydiax.svg": 554,
	"./mulix-crypto.svg": 555,
	"./mulix-payretailers.svg": 556,
	"./mulix-visa.svg": 557,
	"./my-pay.png": 558,
	"./neteller.png": 559,
	"./neteller.svg": 560,
	"./paykasa.png": 561,
	"./payneteasy.svg": 562,
	"./powercash.png": 563,
	"./safecharge.png": 564,
	"./skrill.png": 565,
	"./skrill.svg": 566,
	"./sofort.png": 567,
	"./trustly.png": 568,
	"./visa-mastercard-powercash.svg": 569,
	"./visa-mastercard-safecharge.svg": 570,
	"./visa-mastercard.png": 571,
	"./visa-mastercard.svg": 572,
	"./vload-backup.png": 573,
	"./vload.png": 574
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 240;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/funding ^\.\/.*$
// module id = 240
// module chunks = 0